export default class BaseExporter {
  header

  data

  /**
   * constructor
   * @param data raw array
   * @param header CSV header
   */
  constructor(data = [], header = []) {
    this.data = data
    this.header = header
  }

  /**
   * @return Array
   */
  export() {
    throw new Error('Must be implemented')
  }
}
